<template>
  <div class="container-fluid px-4 px-xl-5 mt-3 mt-xl-0 mb-5">
    <a href="/sixnes-erwtiseis-faq" target="_blank" class="fixed-button-faq" title="Συχνές Ερωτήσεις (FAQ)">
      <span class="button-text"><i class="icofont-info"></i></span>
    </a>
    <button class="fixed-button" data-bs-toggle="modal" data-bs-target="#mapModal">
      <span class="button-text"><i class="icofont-google-map"></i>Προβολή χάρτη</span>
    </button>
    <!-- Breadcrumbs -->
    <nav class="mt-xl-3 mt-1" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item ">
          <router-link class="color-600" to="/">Αρχική</router-link>
        </li>
        <li class="breadcrumb-item active text-dark" aria-current="page"><b>{{ categoryTitle }}</b></li>
      </ol>
    </nav>

    <div class="row d-flex align-items-end text-end mb-4 justify-content-center-mobile">
      <div class="d-flex gap-xl-3 gap-1 justify-content-center-mobile col-12 col-xl-4 w-auto px-1">

        <!-- <button class="mapMobBtn" data-bs-toggle="modal" data-bs-target="#mapModal">
          <span class="button-text"><i class="icofont-google-map"></i></span>
        </button> -->
        <button class="mapMobBtn" data-bs-toggle="modal" data-bs-target="#mapModal">
          <span class="button-text"><i class="icofont-google-map"></i>&nbsp;Προβολή χάρτη</span>
        </button>
        <button @click="randomizeData" :class="['btn-sorting', activeSort === 'random' ? 'active' : '']">
          <i class="icofont-random"></i>&nbsp;
          <span>Τυχαία προβολή</span>
        </button>
        <button @click="sortAlphabetically" :class="['btn-sorting', activeSort === 'alphabetical' ? 'active' : '']">
          <i class="icofont-text-height"></i>&nbsp;
          <span>Αλφαβητικά</span>
        </button>
        <!-- <div class="shortcutBtnDiv">
          <div class="shortcutBtn" data-bs-toggle="modal" data-bs-target="#shortcutModal">
            <i class="icofont-tack-pin fs-3"></i>
          </div>
          <div class="modal fade" id="shortcutModal" tabindex="-1" aria-labelledby="shortcutModalLabel"
            aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title text-start" id="shortcutModalLabel">Προσθέστε τη σελίδα μας <br>στην αρχική σας
                    οθόνη!</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-start">
                  <div>
                    <p class="fs-6">
                      Μπορείτε να δημιουργήσετε μια συντόμευση της σελίδας μας στην αρχική οθόνη του κινητού σας,
                      εξασφαλίζοντας άμεση και εύκολη πρόσβαση με ένα μόνο πάτημα.<br><br>
                      <span class="fw-bold" style="color:#175576"><strong>Για χρήστες Android:</strong></span><br>
                      Απλώς πατήστε το παρακάτω κουμπί και προσθέστε τη σελίδα στην αρχική σας οθόνη.<br><br>
                      <button class="shortcutBtnModal" @click="addToHomeScreen">
                        <span>Προσθήκη συντόμευσης</span>
                        &nbsp;<i class="icofont-ui-home"></i>
                      </button>
                      <br><br>
                      <span class="fw-bold" style="color:#175576"><strong>Για χρήστες iPhone (iOS):</strong></span><br>
                    <div class="ms-3 mt-3">
                      <div class="d-flex gap-2">
                        <span
                          style="background: #54B7F3;color: white;padding: 5px;border-radius: 99px;width: 25px;height: 25px;display: flex;align-items: center;justify-content: center;font-size: 18px;">01</span>Πατήστε
                        το εικονίδιο "Κοινοποίηση" (το τετράγωνο με το βέλος προς τα πάνω) στο κάτω μέρος του Safari.
                        <br>
                      </div>
                      <div class="d-flex gap-2">
                        <span
                          style="background: #54B7F3;color: white;padding: 5px;border-radius: 99px;width: 25px;height: 25px;display: flex;align-items: center;justify-content: center;font-size: 18px;">02</span>Επιλέξτε
                        "Προσθήκη στην αρχική οθόνη" από το μενού που εμφανίζεται.<br>
                      </div>
                      <div class="d-flex gap-2">
                        <span
                          style="background: #54B7F3;color: white;padding: 5px;border-radius: 99px;width: 25px;height: 25px;display: flex;align-items: center;justify-content: center;font-size: 18px;">03</span>Πατήστε
                        "Προσθήκη", και η συντόμευση θα εμφανιστεί στην αρχική σας οθόνη!<br><br>
                      </div>



                    </div>

                    Έτσι θα μπορείτε να επισκέπτεστε τη σελίδα μας εύκολα & γρήγορα!
                    </p>
                  </div>

                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Κλείσιμο
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <div class="col-12 mt-xl-0 mt-3 col-xl-4 d-flex align-items-end justify-content-center gap-3 pe-0">
        <div class="col justify-content-center-mobile">
          <h3 class="color-700 fs-3 mb-0 text-nowrap" style="letter-spacing:2px;"><span
              style="color: #175576;font-size:3rem">•</span> {{ categoryTitle }}</h3>
        </div>
        <div class="col categoryNameSection">
          <!-- <hr> -->
        </div>
      </div>

      <div class="col-10 mob-column col-xl-4 d-flex searchSection justify-content-end">
        <div class="w-75 w-sm-100">
          <form class="ms-auto w-100 w-smScrn-100 mt-3 mt-xl-0 searchDiv" @submit.prevent>
            <input ref="searchInput" v-model="searchQuery" @keyup="search" @click="search"
              class="form-control search-input" type="search" placeholder="Αναζήτηση Επιχείρησης..."
              aria-label="Search">
            <img v-if="!searchQuery" class="search-icon" width="35" src="../assets/images/search-icon.png"
              alt="Search Icon">
            <!-- Search Results Section -->
            <div ref="searchResults" v-if="searchResults.length > 0" class="search-results position-absolute w-100">
              <div class="card" v-for="business in searchResults" :key="business.id">
                <!-- Make the entire card clickable by wrapping it in RouterLink -->
                <RouterLink :to="getLink(business)" class="card-link">
                  <div class="card-body">
                    <span class="card-title fs-6">{{ business.brandname }}</span>
                  </div>
                </RouterLink>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>



    <!-- Business Cards Grid -->
    <div class="row row-cols-1 row-cols-md-3 g-4">
      <div class="col" v-for="business in businesses" :key="business.id">
        <router-link :to="`/profile/${categoryId}/${business.id}`" class="card-link">
          <div class="cardBusiness h-100">
            <div class="image-container">
              <img
                :src="business.top_banner_img ? `/storage/${business.top_banner_img}` : require('@/assets/images/marketplace-logo.jpg')"
                class="card-img-top" :alt="business.brandname" /> <!-- Rounded Badge in the bottom-right corner -->
              <div class="rounded-badge">
                <span>{{ business.brandname }}</span>
              </div>
            </div>
            <div class="card-body pt-3">
              <h5 class="card-title">{{ business.brandname }}</h5>
              <div
                class="d-flex flex-column-mobile align-items-baseline-mobile justify-content-between align-items-center">
                <div>
                  <div class="card-text mb-3 mb-xl-0">
                    <div class="d-flex align-items-center">
                      <div>
                        <img src="../assets/images/map.png" alt="" width="30">
                      </div>
                      <div>
                        {{ business.Address }}
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>
                        <img src="../assets/images/Phone.png" alt="" width="30">
                      </div>
                      <div>
                        {{ business.Phone }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="logo-container" v-if="business.Logo">
                  <img
                    :src="business.Logo ? `/storage/${business.Logo}` : require('@/assets/images/marketplace-logo.jpg')"
                    alt="Logo" class="logo" />
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="modal fade" id="mapModal" tabindex="-1" aria-labelledby="mapModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="mapModalLabel">Χάρτης</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <LeafletMap v-if="isMapVisible" ref="leafletMap" :locations="locations" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Κλείσιμο
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBusinessPartnersPerCategoryId } from '@/services/business-partners';
import { useHead } from '@vueuse/head';
import { getBusinessCategory } from '@/services/category';
import LeafletMap from '@/components/LeaftletMap.vue';
import { searchBusinessPartner } from '@/services/business-partners';
import { getAppInfo } from '@/services/appInfo';

export default {
  components: { LeafletMap },
  name: 'CategoryPage',
  data() {
    return {
      isMapVisible: false,
      locations: [
        // { title: "Nikos", address: "Μιλτιάδου 43, Γλυφάδα, 16675" },
        // { title: "Citrine", address: "Αετιδέων 43, Χολαργός, 15561" }, 
        // ... more markers
      ],
      categoryTitle: '', // Store the category title
      businesses: [], // Store the business data (offers)
      activeSort: 'random',
      searchQuery: '', // Bound to the search input
      searchResults: [] // Array to hold search results
    };
  },
  computed: {
    categoryId() {
      return this.$route.params.id; // Get the category ID from the URL
    }
  },
  methods: {
    initializeMapOnModalShow() {
      const modal = document.getElementById('mapModal');
      modal.addEventListener('shown.bs.modal', () => {
        this.isMapVisible = true; // Render the LeafletMap component
        this.$nextTick(() => {
          if (this.$refs.leafletMap) {
            this.$refs.leafletMap.invalidateSize();
          }
        });
      });

      modal.addEventListener('hidden.bs.modal', () => {
        this.isMapVisible = false; // Unmount the LeafletMap component
      });
    },
    randomizeData() {
      if (Array.isArray(this.businesses)) {
        this.businesses = this.businesses.sort(() => Math.random() - 0.5);
        this.activeSort = 'random';
      } else {
        console.warn('Categories data is not an array.');
      }
    },
    sortAlphabetically() {
      if (Array.isArray(this.businesses)) {
        this.businesses = this.businesses.sort((a, b) =>
          a.brandname.localeCompare(b.brandname)
        );
        this.activeSort = 'alphabetical';
      } else {
        console.warn('Categories data is not an array.');
      }
    },
    async addToHomeScreen() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        const { outcome } = await this.deferredPrompt.userChoice;
        if (outcome === "accepted") {
          console.log("User added the app to the home screen");
        } else {
          console.log("User dismissed the installation prompt");
        }
        this.deferredPrompt = null;
      } else {
        alert("Your browser does not support home screen shortcuts");
      }
    },
    // Fetch businesses per category
    async fetchCategoryBusinesses() {
      try {
        const response = await getBusinessPartnersPerCategoryId({ business_category_id: this.categoryId });
        this.businesses = response.data.success ? response.data.data : [];
        let locations = [];
        if (this.businesses.length) {
          for (let i = 0; i < this.businesses.length; i++) {
            if (this.businesses[i].Lat && this.businesses[i].Lon) {
              locations.push({ "title": this.businesses[i].brandname, "lat": this.businesses[i].Lat, "lon": this.businesses[i].Lon, });
            }
          }
        }
        this.locations = locations;
      } catch (error) {
        console.error('Error fetching offers data', error);
        this.$toast.error('Error fetching offers data');
      }
    },
    async fetchCategories() {
      try {
        const allBusinessPartners = await getAllBusinessPartners();
        let locations = [];
        for (let i = 0; i < allBusinessPartners.data.data.length; i++) {
          if (allBusinessPartners.data.data[i].Lat && allBusinessPartners.data.data[i].Lon) {
            locations.push({ "title": allBusinessPartners.data.data[i].brandname, "lat": allBusinessPartners.data.data[i].Lat, "lon": allBusinessPartners.data.data[i].Lon })
          }
        }
        this.locations = locations;
        const response = await getBusinessCategories();
        if (response.data.success) {
          this.categories = response.data.data; // Correctly access the categories array
        } else {
          console.error('Failed to fetch categories:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    },
    async fetchData() {
      try {
        // Replace with your actual API URL
        const response = await getAppInfo();
        this.apiData = response.data.success ? response.data.data : false;
      } catch (error) {
        this.error = error.message || 'Error fetching data';
        console.error(this.error);
      }
    },
    async search() {
      let self = this;
      setTimeout(async () => {
        // Ensure the search query is at least 2 characters long
        if (self.searchQuery.length < 2) {
          self.searchResults = [];
          return;
        }
        try {
          // Call the search API with the current search query
          const response = await searchBusinessPartner({ search: self.searchQuery });
          self.searchResults = response.data.success ? response.data.data : []; // Assuming the response contains an array of businesses
        } catch (error) {
          console.error('Error searching:', error);
        }
      }, 500);
    },
    resetSearchResults() {
      // Clear search results and search query
      this.searchResults = [];
      this.searchQuery = '';
    },
    // getLink(business) {
    //   if (business.business_category_id && Array.isArray(business.business_category_id)) {
    //     return '/profile/' + business.business_category_id[0] + '/' + business.id;
    //   }
    //   if (business.business_category_id) {
    //     return '/profile/' + business.business_category_id + '/' + business.id;
    //   } else {
    //     return '#';
    //   }
    // },
    getCategoryIdFromUrl() {
      const url = window.location.href; // Get current URL
      const match = url.match(/category\/(\d+)\//); // Extract category ID
      return match ? match[1] : null;
    },

    getLink(business) {
      const categoryIdFromUrl = this.getCategoryIdFromUrl(); // Extract category ID dynamically

      if (categoryIdFromUrl) {
        return `/profile/${categoryIdFromUrl}/${business.id}`;
      }

      if (business.business_category_id && Array.isArray(business.business_category_id)) {
        return `/profile/${business.business_category_id[0]}/${business.id}`;
      }
      if (business.business_category_id) {
        return `/profile/${business.business_category_id}/${business.id}`;
      }
      return '#';
    },
    handleClickOutside(event) {
      const searchInput = this.$refs.searchInput;
      const searchResults = this.$refs.searchResults;

      if (
        searchInput && !searchInput.contains(event.target) &&
        searchResults && !searchResults.contains(event.target)
      ) {
        this.resetSearchResults();
      }
    },
  },
  async mounted() {
    this.fetchData();
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
    });
    // Set the category title based on the category ID from the URL
    if (this.categoryId) {
      const c = await getBusinessCategory(this.categoryId);
      if (c.data.success) {
        this.categoryTitle = c.data.data.title;
      }
    }
    // Fetch the business data (offers) from the API
    this.fetchCategoryBusinesses();
    this.initializeMapOnModalShow();

    useHead({
      title: `Κατηγορίες - ${this.categoryTitle}`,
      meta: [
        { name: 'description', content: `Κατηγορίες - ${this.categoryTitle}` },
        { property: 'og:title', content: `Κατηγορίες - ${this.categoryTitle}` },
        { property: 'og:description', content: `Κατηγορίες - ${this.categoryTitle}` }
      ]
    });
  }
};
</script>

<style scoped>
.btn-sorting.active {
  background: #175576;
  color: #ffffff !important;
}

.btn-sorting {
  background: #ffffff;
  border: 1px solid #175576 !important;
  color: #175576 !important;
  padding: 1px 5px;
  border-radius: 99px;
}

.btn-sorting:hover {
  background: #8FBDE9;
  color: #ffffff !important;
  transition: .5s;
  border: 1px solid #8FBDE9 !important;
}

.fixed-button-faq{
    position: fixed;
    top: 55%;
    right: 0;
    background-color: #175576;
    color: #fff;
    border: none;
    border-radius: 10px 0px 0px 10px;
    width: 32px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    z-index: 1000;
}

.fixed-button-faq:hover {
  background-color: #8FBDE9;
  color: white;
}

.fixed-button {
  position: fixed;
  top: 75%;
  right: 0;
  transform: translateY(-50%);
  background-color: #175576;
  color: #fff;
  border: none;
  border-radius: 10px 0px 0px 10px;
  width: 32px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 1000;
  /* Ensures the button appears above other elements */
}

.fixed-button:hover {
  background-color: #8FBDE9;
}

.icofont-eye {
  font-size: 1.5rem;
  margin-bottom: 5px;
  writing-mode: vertical-rl;
  /* Makes text vertical */
  transform: rotate(180deg);
  /* Flips text to read correctly */
}

.fixed-button .button-text {
  writing-mode: vertical-rl;
  /* Makes text vertical */
  transform: rotate(180deg);
  /* Flips text to read correctly */
  font-size: 1rem;
  letter-spacing: 1px;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* Ensures text aligns properly */
}

.fixed-button .icofont-google-map {
  font-size: 24px;
  margin-bottom: 10px;
  writing-mode: vertical-lr;
  transform: rotate(180deg);
}

/* Modal Adjustments */


.modal-content {
  border-radius: 10px;
  margin-bottom: 10px;
}

a:hover {
  transition: 1s;
  color: #A27B52;
}

.breadcrumb {
  background-color: transparent;
  padding-top: 0px;
}

.title-with-line {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 30px;
}

.category-title {
  flex-shrink: 0;
  padding-left: 20px;
  /* Space between the line and the title */
  font-size: 2rem;
}

.title-with-line::before {
  content: '';
  flex-grow: 1;
  height: 2px;
  background-color: #000;
  /* Line color */
}

.image-container {
  position: relative;
  height: 250px;
  /* Fixed height for consistency */
  overflow: hidden;
}

.card-img-top {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 30px;
  border: 1px solid #eee;
}

/* Rounded Badge */
.rounded-badge {
  position: absolute;
  bottom: 1px;
  right: 40px;
  background-color: #A27B52;
  padding: 2px 8px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-size: 1rem;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.card-body {
  text-align: left;
}

.card-title {
  font-size: 1.50rem;
  font-weight: bold;
  padding-left: 5px;
}

.card-text {
  font-size: 0.9rem;
  margin-bottom: 15px;
}

.logo {
  max-height: 50px;
  height: 40px
}

.badge {
  font-size: 0.85rem;
  padding: 0.5em 1em;
  border-radius: 5px;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.card {
  cursor: pointer;
  z-index: 1;
  background: transparent;
}

.cardBusiness {
  box-shadow: 3px 3px 10px 5px #eee;
  padding: 15px;
  border-radius: 30px;
}

.card-body {
  border-bottom: 0px solid #dedede;
}

.card-link {
  display: block;
  text-decoration: none;
  color: inherit;
  /* Prevent RouterLink from changing the text color */
  z-index: 99999;
}

.card-link:hover {
  text-decoration: none;
}

.search-input {
  background: #fff;
  border-width: 0px 0px 0px 0px;
  border-color: #175576;
  border-style: solid;
  color: #175576;
  /* box-shadow: inset 0px 0px 10px 0px #dedede; */
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  text-align: center;
}

.form-control:focus,
.form-select:focus {
  box-shadow: 0px 0px !important;
}

.searchDiv {
  position: relative;
  /* Ensures absolute positioning is relative to this */
  width: 100%;
  display: flex;
  align-items: center;
}

.shortcutBtn {
  display: none;
}

.mapMobBtn {
  /* display: none; */
  background: #175576;
  color: #fff;
  border: 0px;
  border-radius: 99px;
  padding: 1px 5px;
}

.search-results {
  background: #fff;
  box-shadow: inset 0px 0px 10px 0px #dedede;
  border-radius: 8px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  z-index: 10;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 38px;
  top: 0;
}

.searchSection {
  border-width: 0px 1px 1px 0px;
  border-color: #175576;
  border-style: solid;
  border-radius: 99px;
  border-bottom-left-radius: 0px;
}

.categoryNameSection {
  border-width: 0px 0px 1px 0px;
  border-color: #175576;
  border-style: solid;
}

@media only screen and (max-width: 1199px) {
  .card-title {
    font-size: 1.25rem;
  }

  .flex-column-mobile {
    flex-direction: column;
  }

  .align-items-baseline-mobile {
    align-items: baseline !important;
  }

  .breadcrumb {
    justify-content: center;
    margin-bottom: 0;
    padding-bottom: 20px;
    padding-top: unset;
  }

  .logo-container {
    margin: 0 auto;
  }

  .mob-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .search-input {
    width: fit-content;
  }

  .mapMobBtn {
    display: unset;
    /* background: #175576;
        font-size: 16px;
        border: 0px;
        color: #fff;
        border-radius: 100%;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center; */
  }

  .categoryNameSection {
    border-width: 0px 0px 0px 0px;
    display: none;
  }

  .searchSection {
    border-width: 0px 0px 1px 0px;
    border-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .categoryNameSection {
    display: none;
  }

  .justify-content-center-mobile {
    justify-content: center !important;
    display: flex;
  }

  .shortcutBtn {
    position: fixed;
    top: 80%;
    right: 0%;
    background: #175576;
    color: #fff;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding: 3.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    width: 26px;
  }

  .shortcutBtnModal {
    background: #175576;
    color: #fff;
    border: 0px;
    justify-content: center;
    display: flex;
    align-items: center;
    border-radius: 99px;
    font-size: 1rem;
    padding: 2px 15px;
    margin: 0 auto;
  }

  .search-results {
    top: 0;
  }

  .modal {
    z-index: 9999;
  }

  .fixed-button .icofont-google-map {
    font-size: 18px;
    /* right: 3px; */
    position: relative;
  }

  .fixed-button {
    top: 61%;
    width: 28px;
    padding: 6px;
  }
  .fixed-button-faq{
      top: 46%;
      width: 28px;
      padding: 6px;
    
  }
}
</style>